import { Path } from '@vimeo/iris/components';
import { Header, Link, Paragraph } from '@vimeo/iris/typography';

import GuideWrapper from 'src/_components/GuideWrapper';
import Meta from 'src/_components/Meta';
import StyledNotice from 'src/_components/StyledNotice';

export default function Player() {
  return (
    <>
      <Meta
        title="Player SDK: About the Player SDK"
        description="Get an overview of the Vimeo player SDK."
      />
      <GuideWrapper
        breadcrumbs={
          <Path>
            <Path.Link href={'/'}>Home</Path.Link>
            <Path.Link href={'/api/guides/start'}>API</Path.Link>
            <Path.Current>Player SDK</Path.Current>
          </Path>
        }
        nav={{ page: 'player-sdk', subpage: 'player-sdk' }}
        showContextualMenu={false}
      >
        <Header id="about-the-player-sdk">About the Player SDK</Header>
        <Paragraph size="2">
          Our player SDK enables you to interact with embedded Vimeo players through the code in
          your web page. You can modify the default behavior of the player for features like
          autostart and looping, execute custom functions in response to playback events, and even
          set basic properties like the onscreen dimensions of the player and the color of the
          controls.
        </Paragraph>

        <Paragraph size="2">
          The SDK, as a JavaScript library, is completely separate from the API. You connect to it
          differently, and it gives you a different range of options.
        </Paragraph>

        <StyledNotice>
          <strong>NOTE:</strong> The player SDK works with any of the following browsers: Microsoft
          Edge, Internet Explorer 11 or better, Chrome, Firefox, Safari, and Opera.
        </StyledNotice>

        <Paragraph size="2">
          In this section of the developer site, you get tutorials and reference docs aplenty for
          installing and using the player SDK:
        </Paragraph>

        <ul>
          <li>
            <Link variant="minimal" href={'/player/sdk/basics'}>
              The Basics
            </Link>
          </li>
          <li>
            <Link variant="minimal" href={'/player/sdk/reference'}>
              Reference
            </Link>
          </li>
          <li>
            <Link variant="minimal" href={'/player/sdk/embed'}>
              Embed options
            </Link>
          </li>
        </ul>
      </GuideWrapper>
    </>
  );
}
